import styled from 'styled-components';
import RadioInput from '../../components/Radio/RadioInput';

const StyledLogin = styled.div`
    text-align:center;
    input{
        background: ${({ theme }) => theme.whiteColor};
        border: 1px solid #DEDEDF;
        border-radius: 4px;
        padding: 15px;
        height: auto;
    }
    .otp{
        margin:10px 0px 15px 0px;
        padding:0px;
        list-style:none;
    }
    .login_popup{
        padding:30px;
        margin:0 auto;
        .set-pw{
            ${RadioInput}{
                float:left;
                width:30%;
                text-align:left;
                margin-bottom:20px;
            }
        }
        ul{
            margin:0px;
            padding:0px;
            margin-bottom:20px;
            text-align: left;
            li{
                list-style: none;
                display: inline-block;
                width: 50%;
                position: relative;
                cursor: pointer;
                text-align: center;
                font-size: 20px;
                color: ${(props) => props.theme.primaryColor};
                font-weight: 500;
                &.width100{
                    width:100%;
                }
                span{
                    display:inline-block;
                    text-decoration:none;
                    padding:10px 0px;
                    background:${({ theme }) => theme.transparentColor};
                    box-sizing: border-box;
                    width:100%;
                    /* &:after{
                        content: "";
                        border: 1px solid #B3B3B3;
                        position: absolute;
                        bottom: 0;
                        width: 100%;
                        left: 0;
                    } */
                    &.active{
                        box-sizing: border-box;
                        background:${({ theme }) => theme.transparentColor};
                        font-weight:bold;
                        color: ${({ theme }) => theme.secondaryColor};
                        box-sizing: border-box;
                        &:after{
                            content: "";
                            border: 2px solid ${({ theme }) => theme.primaryColor};
                            position: absolute;
                            bottom: 0;
                            width: 100%;
                            left: 0;
                        }
                    }
                }
            }
        }
    }
    .middle_line{
        line-height: 0px;
        margin: 40px 0px;
        span{
            background: #e2e2e2;
            padding:0px 10px;
        }
        &:after{
            content:"";
            border-bottom:solid 1px #aaa;
            width:100%;
            display:block;
        }
    }
    .face{
        border-radius:50%;
        background:#33589b;
        width:50px !important;
        height:50px;
        color: ${({ theme }) => theme.whiteColor};
        text-align:center;
        padding:0px;
    }
    .gplus{
        border-radius:50%;
        background:#e45031;
        width:50px !important;
        height:50px;
        color: ${({ theme }) => theme.whiteColor};
        text-align:center;
        padding:0px;
    }
    .form-element{
        margin-bottom:10px;
    }
    .links{
        font-size:12px;
        margin-top:10px;
        cursor: pointer;
        color: ${(props) => props.theme.primaryColor};
        text-decoration:underline;
        &.left{
            float:left;
        }
        &.right{
            float:right;
        }
    }
    .nomargin{
        margin:0px;
    }
`;

export default StyledLogin;



// WEBPACK FOOTER //
// client/containers/LoginPage/StyledLogin.js